/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-volume-mute': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M19.375 7.756l-.881-.881-2.244 2.244-2.244-2.244-.881.881L15.369 10l-2.244 2.244.881.881 2.244-2.244 2.244 2.244.881-.881L17.131 10l2.244-2.244zM11.25 18.75a.625.625 0 01-.444-.188L6.044 13.75H1.875a.625.625 0 01-.625-.625v-6.25c0-.345.28-.625.625-.625h4.169l4.762-4.813a.625.625 0 01.882 0 .625.625 0 01.187.438v16.25c0 .345-.28.625-.625.625zM2.5 12.5h3.75a.731.731 0 01.494.188l3.881 3.918V3.394L6.744 7.312a.731.731 0 01-.494.188H2.5v5z"/>'
  }
})
